import xss from "xss" 
import { errMsg } from "../utils/message";
import { regex } from "../utils/regex";
import UmdOption from "./UmdOption";
class Provider {
    constructor(){
        //----화면에서 사용----
        this.providerId = "";
        this.isBirth = false

        //-----Mobile 관련 --------
        this.reqTxId = "";
        
        this.deeplinkUri = ""; // 삼성패스 | 공공 uriScheme 규격
        this.naverAppSchemeUrl = ""; // 네이버 SchemeUrl
        
        this.telcoTxid = "";
        //-------------------

        //----백단에서 사용----
        this.provider = "";
        this.token = "";
        this.txId = "";
        this.cxId = "";
        this.appInfo = {
            code: "",
            path: "",
            type: ""
        }
        this.userInfo = {
            isMember: false,
            name: "",
            phone: "",
            ssn1: "",
            ssn2: "",
            birthday: "",
            privacy: 1,
            terms: 1,
            policy3: 1,
            policy4: 1,
            telcoTycd: null, //S,K,L
            access_token: "",
            token_type:"",
            state:"",
            mtranskeySsn2 : null
        }
        this.deviceInfo = {
          code: "", // PC/MO/TB
          browser: "", // WB/WBK/HY/NA
          os:"", //IOS/AOS
          universalLink: false // true, false
        }
        this.contentInfo = {
          signTarget: "",
          signTargetTycd: "",
          signType: "",
          requestTitle:"",
          requestContents:""
        }
        this.providerOptionInfo = {
					callbackUrl: "",
          reqCSPhoneNo: "1",
					upmuGb: "",
					isUseTss: "Y",
					isNotification: "Y", //PC(Y), MO(N)
					isPASSVerify: "Y",
					isUserAgreement: "Y"
				}
        this.compareCI = false;
        //-------------------
    }

    clear(){
        this.providerId = "";
        this.reqTxId = "";
        this.deeplinkUri = "";
        this.telcoTxid = "";
        this.provider = "";
        this.token = "";
        this.txId = "";
        this.cxId = "";
        this.userInfo = {            
          isMember: false,
          name: "",
          phone: "",
          ssn1: "",
          ssn2: "",
          birthday: "",
          privacy: 1,
          terms: 1,
          policy3: 1,
          policy4: 1,
          telcoTycd: null, //S,K,L
          access_token: "",
          token_type:"",
          state:"",
          mtranskeySsn2 : null
        }
    }

    isEnt(){
      if(this.contentInfo.signType === 'ENT_SIMPLE_AUTH' || this.contentInfo.signType === 'ENT_SIMPLE_SIGN'){
        return true
      }else{
        return false
      }
    }
    isGov(){
      if(this.contentInfo.signType === 'GOV_SIMPLE_AUTH' || this.contentInfo.signType === 'GOV_SIMPLE_SIGN'){
        return true
      }else{
        return false
      }
    }
    setProvider(json){
        this.clear()
        if(!!json.appInfo){
          this.appInfo = {
              code: !!json.appInfo.code ? json.appInfo.code :"",
              path: !!json.appInfo.path ? json.appInfo.path :"",
              type: !!json.appInfo.type ? json.appInfo.type :"",
          }
        }
        if(!!json.deviceInfo){
          this.deviceInfo = {
            code: !!json.deviceInfo.code ? json.deviceInfo.code :"",
            browser: !!json.deviceInfo.browser ? json.deviceInfo.browser :"",
            os: !!json.deviceInfo.os ? json.deviceInfo.os :"",
          }
        }
        if(!!json.contentInfo){
          this.contentInfo = {
            signTarget: !!json.contentInfo.signTarget ? xss(json.contentInfo.signTarget) :"",
            signType: !!json.contentInfo.signType ? json.contentInfo.signType :"",
            requestTitle: !!json.contentInfo.requestTitle ? json.contentInfo.requestTitle :"",
            requestContents: !!json.contentInfo.requestContents ? json.contentInfo.requestContents :""
          }
          if (json.contentInfo.signType === 'GOV_SIMPLE_AUTH' || json.contentInfo.signType === 'ENT_SIMPLE_AUTH') {
            this.contentInfo.signTargetTycd = json.contentInfo.signTargetTycd || 'nonce'
          } else {
            this.contentInfo.signTargetTycd = json.contentInfo.signTargetTycd || 'hash'
          } 
        }
        if(!!json.providerId){
          this.provider = json.providerId + "_v1.5" 
          this.providerId = json.providerId
        }

        if(!!json.userInfo){
          this.userInfo.name = !!json.userInfo.name ? json.userInfo.name :""
          if(!!json.userInfo.phone1 && !!json.userInfo.phone2){
            this.userInfo.phone = json.userInfo.phone1 + json.userInfo.phone2
          }
          this.userInfo.telcoTycd = !!json.userInfo.telcoTycd ? json.userInfo.telcoTycd :""
          this.userInfo.ssn1 = !!json.userInfo.ssn1 ? json.userInfo.ssn1 :""
          this.userInfo.ssn2 = !!json.userInfo.ssn2 ? json.userInfo.ssn2 :""
          this.userInfo.birthday = !!json.userInfo.birthday ? json.userInfo.birthday :""

          //개인정보 이용 동의 확인 여부
          this.userInfo.privacy = json.userInfo.policy1==1 ? 1:0;
          //서비스 이용약관 동의 확인 여부
          this.userInfo.policy3 = json.userInfo.policy2==1 ? 1:0;
          //제3자 정보제공약관 확인 여부
          this.userInfo.policy4 = json.userInfo.policy3==1 ? 1:0;
          //고유식별정보처리 동의 확인 여부
          this.userInfo.terms = json.userInfo.policy4==1 ? 1:0;
        }

        if(!!json.compareCI){
          this.compareCI = json.compareCI;
        }

        if(!!json.isBirth ){
          this.isBirth = json.isBirth;
        }

    }
    userInfoDisabled(){
      !!this.userInfo.name ?  UmdOption.style.userInfo.name.off() : ''
      !!this.userInfo.birthday ? UmdOption.style.userInfo.birthday.off() : ''
      !!this.userInfo.ssn1 ? UmdOption.style.userInfo.ssn1.off() : ''
      !!this.userInfo.ssn2 ? UmdOption.style.userInfo.ssn2.off() : ''
      !!this.userInfo.phone ? UmdOption.style.userInfo.phone1.off() : ''
      !!this.userInfo.phone ? UmdOption.style.userInfo.phone2.off() : ''
      !!this.userInfo.telcoTycd ? UmdOption.style.userInfo.telcoTy.off() : ''
    }
    getUserInfoValidMesseg(json){
      if(!!json.userInfo){
        // 이름 빈값 체크
        if(!!!json.userInfo.name){ return errMsg.OACX_USERINFO_NAME_EMPTY_ERROR }
        if(json.userInfo.name.length > 50){ return errMsg.OACX_USERINFO_NAME_SIZE_ERROR }
        // 이름 한글, 영문 체크
        if(!regex.isKorEng(json.userInfo.name)){ return errMsg.OACX_USERINFO_NAME_VALID_ERROR }
        
        if(json.isBirth){
          // isBirth: true  생년월일 체크
          // 생년월일 빈값 체크
          if(!!!json.userInfo.birthday){ return errMsg.OACX_USERINFO_BIRTH_EMPTY_ERROR }
          // 생년월일 숫자 체크
          if(!regex.isNum(json.userInfo.birthday)){ return errMsg.OACX_USERINFO_BIRTH_NUMBER_ERROR }
          // 생년월일 형식 검증
          if(!regex.isBirth(json.userInfo.birthday)){ return errMsg.OACX_USERINFO_BIRTH_VALID_ERROR }
        }else{
          // isBirth: false 주민번호 체크
          // 주민번호 빈값 체크
          if(!!!json.userInfo.ssn1){ return errMsg.OACX_USERINFO_SSN1_EMPTY_ERROR }
          if(!!!json.userInfo.ssn2){ return errMsg.OACX_USERINFO_SSN2_EMPTY_ERROR }
          // 주민번호 숫자 체크
          if(!regex.isNum(json.userInfo.ssn1)){ return errMsg.OACX_USERINFO_SSN1_NUMBER_ERROR }
          if(!regex.isNum(json.userInfo.ssn2)){ return errMsg.OACX_USERINFO_SSN2_NUMBER_ERROR }
          // 주민번호 입력 형식 체크
          if(!regex.isValidBirthday(regex.convertBirthDay(json.userInfo.ssn1, json.userInfo.ssn2))){ return errMsg.OACX_USERINFO_SSN_VALID_ERROR }
          if(!regex.isValidRnNum(json.userInfo.ssn1, json.userInfo.ssn2)){ return errMsg.OACX_USERINFO_SSN_VALID_ERROR }
        }

        // 인증기관ID 체크
        if(!!!json.providerId){ return errMsg.OACX_PROVIDER_EMPTY_ERROR }

        // 인증기관이 통신사 패스 일 때
        if(!!json.providerId.match("pass")){
          // 통신사 빈값 체크
          if(!!!json.userInfo.telcoTycd){ return errMsg.OACX_USERINFO_TELCO_EMPTY_ERROR }
          // 통신사 S, K, L 입력형식 체크
          if(!!!json.userInfo.telcoTycd.match("S")){ return errMsg.OACX_USERINFO_TELCO_VALID_ERROR }
          if(!!!json.userInfo.telcoTycd.match("K")){ return errMsg.OACX_USERINFO_TELCO_VALID_ERROR }
          if(!!!json.userInfo.telcoTycd.match("L")){ return errMsg.OACX_USERINFO_TELCO_VALID_ERROR }
        }

        // 휴대폰번호 빈값 체크
        if(!!!json.userInfo.phone1){ return errMsg.OACX_USERINFO_PHONE_EMPTY_ERROR }
        if(!!!json.userInfo.phone2){ return errMsg.OACX_USERINFO_PHONE_EMPTY_ERROR }
        // 휴대폰번호 숫자 체크
        if(!regex.isNum(json.userInfo.phone1)){ return errMsg.OACX_USERINFO_PHONE_NUMBER_ERROR }
        if(!regex.isNum(json.userInfo.phone2)){ return errMsg.OACX_USERINFO_PHONE_NUMBER_ERROR }
        // 휴대폰번호 유효성 검증
        if(json.userInfo.phone1 != "010" && json.userInfo.phone1 != "011" &&
          json.userInfo.phone1 != "016" && json.userInfo.phone1 != "017" &&
          json.userInfo.phone1 != "018" && json.userInfo.phone1 != "019")
          { return errMsg.OACX_USERINFO_PHONE_VALID_ERROR }
        if(json.userInfo.phone2.length < 7 || json.userInfo.phone2.length > 8){ return errMsg.OACX_USERINFO_PHONE_VALID_ERROR }
        // 개인정보 이용 동의 확인 여부
        if(json.userInfo.policy1 == 0 || json.userInfo.policy1 == 1){ return errMsg.OACX_USERINFO_POLICY1_VALID_ERROR}
        if(json.userInfo.policy2 == 0 || json.userInfo.policy2 == 1){ return errMsg.OACX_USERINFO_POLICY2_VALID_ERROR}
        if(json.userInfo.policy3 == 0 || json.userInfo.policy3 == 1){ return errMsg.OACX_USERINFO_POLICY3_VALID_ERROR}
        if(json.userInfo.policy4 == 0 || json.userInfo.policy4 == 1){ return errMsg.OACX_USERINFO_POLICY4_VALID_ERROR}
      }
      return ""
    }
}
export default (new Provider);